import { INPUT_LIMITS } from 'const/constants'
import { isValidLength } from 'helpers/utils/utils'
import { ZipCodeErrors } from 'strings/lang/translations.types'

export const getZipCodeError = (zipCode: string) => {
  let error: ZipCodeErrors | '' = ''
  if (zipCode.length === 0) {
    error = 'zipCodeEmptyError'
  } else if (!isValidLength(zipCode, INPUT_LIMITS.ZIP_CODE)) {
    error = 'zipCodeIncompleteError'
  }
  return error
}
